<template>
  <SvgBase iconName="IconUnlock" width="22" height="22">
    <path
      d="M14.8042 8.77344H2.07904C1.4831 8.77344 1 9.34999 1 10.0612V19.6943C1 20.4055 1.4831 20.9821 2.07904 20.9821H14.8042C15.4002 20.9821 15.8833 20.4055 15.8833 19.6943V10.0612C15.8833 9.34999 15.4002 8.77344 14.8042 8.77344Z"
      stroke="white"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M4.44185 8.77392V5.01763C4.41159 4.50078 4.49262 3.9835 4.68001 3.49742C4.8674 3.01135 5.15718 2.56669 5.53166 2.19063C5.90615 1.81458 6.35748 1.51503 6.858 1.31031C7.35852 1.10559 7.89773 1 8.44268 1C8.98763 1 9.52688 1.10559 10.0274 1.31031C10.5279 1.51503 10.9792 1.81458 11.3537 2.19063C11.7282 2.56669 12.018 3.01135 12.2054 3.49742"
      stroke="white"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </SvgBase>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import SvgBase from './SvgBase.vue'

@Options({
  components: {
    SvgBase,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
})
export default class IconUnlock extends Vue {}
</script>
